import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';

export const request = (config) => axios.request({ responseType: 'json', method: 'get', ...config });
export const get = request;
export const post = (config) => request({ ...config, method: 'post' });
export const put = (config) => request({ ...config, method: 'put' });
export const del = (config) => request({ ...config, method: 'delete' });
export const getAuth = (bearer, config) => get({ headers: { Authorization: `Bearer ${bearer}` }, ...config });
export const postAuth = (bearer, config) => post({ headers: { Authorization: `Bearer ${bearer}` }, ...config });
export const putAuth = (bearer, config) => put({ headers: { Authorization: `Bearer ${bearer}` }, ...config });
export const getParams = (config) => request({ ...config, method: 'get' });
export const download = (config) => request({ ...config, method: 'get' });
